import { Box, Paper } from "@material-ui/core";
import { AgGridReact } from "ag-grid-react";

import { ChemistrySample } from "@/pages/caster/models/ElementData";
import { useTableStyles } from "@/pages/heat-report/styles/useTableStyles";
import { useElementTableData } from "./hooks/useElementTableData";
import { useElementStyles } from "./styles/useElementStyles";

export const ElementTable = ({
	elementList,
}: { elementList: ChemistrySample[] }) => {
	const commonTableClasses = useTableStyles();
	const localClasses = useElementStyles();

	const { columns, rowData, getRowStyle } = useElementTableData({
		elementList,
	});

	const gridHeight = 20 + rowData.length * 35 + 2;
	const minHeight = 100;

	return (
		<>
			<Paper
				className={commonTableClasses.borderAgGridTable}
				elevation={0}
				style={{ margin: "10px 0px" }}
			>
				<Box p={0}>
					<div
						style={{
							height: `${Math.max(gridHeight, minHeight)}px`,
							minWidth: "100%",
						}}
					>
						<AgGridReact
							rowData={rowData}
							columnDefs={columns}
							suppressRowClickSelection={true}
							suppressPaginationPanel={true}
							suppressContextMenu
							getRowId={(params) => params.data.id}
							getRowStyle={getRowStyle}
							noRowsOverlayComponent={() => "No chemistry data available"}
						/>
					</div>
				</Box>
			</Paper>
		</>
	);
};
